import { Text } from '@chakra-ui/react';
import React from 'react';

import { pageNames } from '../../constants/Page';
import Wireframe from '../wireframe/Wireframe';

/**
 *
 */
type SucceededProps = unknown;

/**
 *
 * @returns
 */
const Succeeded: React.FunctionComponent<SucceededProps> = (props) => {
  return (
    <Wireframe title={pageNames.SUCCEEDED}>
      <Text>報告しました</Text>
    </Wireframe>
  );
};

export default Succeeded;
